
          import React from "react";
        
           const OrderFilter = ({
  activeTab,

  filter,
  setFilter,

  startDate,
  setStartDate,

  endDate,
  setEndDate,

  search,
  setSearch,

  paymentFilter,
  setPaymentFilter,

  orderTypeFilter,
  setOrderTypeFilter,

  historyStartDate,
  setHistoryStartDate,

  historyEndDate,
  setHistoryEndDate,

  handleHistorySearch,
  loadingOrders,

  filteredHistory,
  exportAnyJsonToExcel,

  today,

  setSelectedSummaryDate,
  setShowSummaryModal,

  setSelectedMergedDate,
  setShowMergedModal,
}) => {
    return (
      <>
        
        {/* Filters */}
        {(activeTab === "current" || activeTab === "schedule") && (
          <div className="flex flex-wrap items-center gap-2 mb-4 montserrat-font-1">
            {[
              { label: "Active + Initiated Orders", value: "all" },
              { label: "Active", value: "active" },
              { label: "Dining", value: "dining" },
              { label: "Rejected", value: "rejected" },
            ].map((btn) => (
              <button
                key={btn.value}
                onClick={() => setFilter(btn.value)}
                className={`px-3 py-1 text-sm rounded border ${
                  filter === btn.value
                    ? "bg-blue-500 text-white"
                    : "bg-white text-gray-600"
                }`}
              >
                {btn.label}
              </button>
            ))}

            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="border px-2 py-1 rounded text-sm"
            />
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="border px-2 py-1 rounded text-sm"
            />
            <input
              type="text"
              placeholder="Search by Order ID / Name / Mobile..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border px-3 py-1 rounded text-sm w-52"
            />

            <select
              value={paymentFilter}
              onChange={(e) => setPaymentFilter(e.target.value)}
              className="border px-3 py-1 rounded text-sm"
            >
              <option value="all">All Payment</option>
              <option value="cod">COD</option>
              <option value="upi">UPI (Paid)</option>
              <option value="unpaid">Unpaid</option>
            </select>

            <select
              value={orderTypeFilter}
              onChange={(e) => setOrderTypeFilter(e.target.value)}
              className="border px-3 py-1 rounded text-sm"
            >
              <option value="all">All Orders</option>
              <option value="home_delivery">Home Delivery</option>
              <option value="dining">Dining</option>
              <option value="takeaway">Takeaway</option>
              <option value="car_order">Car Order</option>
              <option value="office_order">Office Order</option>
            </select>
          </div>
        )}

        {activeTab === "history" && (
          <div className="flex items-center gap-3 mb-4 montserrat-font-1">
            <input
              type="text"
              placeholder="Search by Order ID / Name / Mobile / Table..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border px-3 py-2 rounded text-sm w-64"
            />
            <input
              type="date"
              value={historyStartDate}
              onChange={(e) => setHistoryStartDate(e.target.value)}
              className="border px-2 py-2 rounded text-sm"
            />

            <input
              type="date"
              value={historyEndDate}
              onChange={(e) => setHistoryEndDate(e.target.value)}
              className="border px-2 py-2 rounded text-sm"
            />

            <button
              onClick={handleHistorySearch}
              disabled={loadingOrders}
              className={`px-4 py-2 rounded text-sm text-white ${
                loadingOrders
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-green-500 hover:bg-green-600"
              }`}
            >
              {loadingOrders ? "Searching..." : "Search"}
            </button>
            <button
              onClick={() =>
                exportAnyJsonToExcel({
                  data: filteredHistory,
                  filePrefix: `Order_History_${historyStartDate}_to_${historyEndDate}`,
                  sheetName: "Orders",
                })
              }
              className="bg-blue-500 text-white px-4 py-2 rounded text-sm"
            >
              Excel
            </button>

            <button
              className="bg-green-500 text-white px-4 py-2 rounded text-sm"
              onClick={() => {
                setSelectedSummaryDate(historyEndDate || today);
                setShowSummaryModal(true);
              }}
            >
              Summary
            </button>

            <button
              className="bg-purple-500 text-white px-4 py-2 rounded text-sm"
              onClick={() => {
                setSelectedMergedDate(historyEndDate || today);
                setShowMergedModal(true);
              }}
            >
              Merged Summary
            </button>
          </div>
        )}
            </>
       );
};

export default OrderFilter;